module.exports = __webpack_public_path__ + "static/hero-bg-4d29310115c2f7b99f1055ab95be16e3.jpg";